// Simple reference-counted body scroll lock to avoid stuck overflow
let lockCount = 0;
let prevOverflow = "";

export function lockBodyScroll() {
  if (typeof document === "undefined") return;
  if (lockCount === 0) {
    prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
  }
  lockCount += 1;
}

export function unlockBodyScroll() {
  if (typeof document === "undefined") return;
  if (lockCount > 0) {
    lockCount -= 1;
    if (lockCount === 0) {
      document.body.style.overflow = prevOverflow || "";
    }
  }
}
